import type { SxStyle } from '@aibees/shared/theme';

export const paper: SxStyle = {
  bgcolor: 'common.black',
  maxWidth: 880,
  width: '100%',
  overflow: 'hidden',
  borderRadius: 1.5,
};

export const closeButton: SxStyle = {
  position: 'absolute',
  top: 12,
  right: 12,
  zIndex: 2,
  width: 32,
  height: 32,
  bgcolor: 'rgba(0,0,0,.7)',
  color: 'common.white',
  '&:hover': {
    bgcolor: 'rgba(0,0,0,.85)',
  },
};

export const playerWrap: SxStyle = {
  position: 'relative',
  width: '100%',
  aspectRatio: '16 / 9',
};

export const iframe: SxStyle = {
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  border: 0,
};

export const meta: SxStyle = {
  p: 2,
  color: 'common.white',
};
